import React, { useState, useEffect } from 'react'
import { Icon, Image, Menu, Segment, Sidebar, Grid, Dropdown } from 'semantic-ui-react'
import { Outlet, Route, Routes, useLocation, useNavigate, useResolvedPath } from 'react-router-dom'
import GuestHouseBookings from './GuestHouseBooking'
import GuestHousePackages from './GuestHousePackage'
import APIService from '../../Services/API/APIService'
import { useAuth } from '../../Context/AppContext'
import Success from '../HomeContainer/Success'
import CustomersActivity from './CustomersActivity'
import CompletedBookings from './CompletedBookings'
import PastRecords from './PastRecords'
import BackOffice from './BackOffice'
import Resturant from './Resturant'
import MonthlyRecords from './MonthlyRecords'
import { toast } from 'react-toastify'
const DashboardLayout = (props) => {
  const authCtx = useAuth()
  const location = useLocation()
  const [sideBarVisible, setSidebarVisible] = useState(true)
  const [currentPath, setCurrentPath] = useState(location?.pathname);
  const [notifications, setNotifications] = useState(null)
  const [bookId, setBookId] = useState([])

  const navigate = useNavigate()
  const url = useResolvedPath("").pathname

  useEffect(() => {
    if (currentPath !== location.pathname) {
      setCurrentPath(location.pathname);
    }

    const user = APIService.fetchUser();
    if (user && !authCtx.user) {
      authCtx.login(user); 
    }
  }, [location.pathname, authCtx, currentPath]);

  useEffect(() => {
    
  const fetchData = async () => {

    try {
      let result = await APIService.getData('/guest-house/overDueCheckout')
      setNotifications((prev) => (prev !== result.count ? result.count : prev));
      setBookId((prev) => (JSON.stringify(prev) !== JSON.stringify(result.response) ? result.response : prev));
    } catch (error) {
      console.log(error);
    }
  }

   fetchData()

  }, []);


  const _logout = async () => {
    try {
      await APIService.signOut();
    } catch (error) {
      toast.warn(error)
    }
  };

  return (
    <Sidebar.Pushable as={Segment}>
      <Sidebar
        as={Menu}
        animation='slide along'
        icon='labeled'
        style={{ backgroundColor: '#37423e' }}
        vertical
        visible={sideBarVisible}
        width='thin'
        inverted
      >
        <Menu.Item >
          <Image
            src={
              "https://res.cloudinary.com/duknzdiyw/image/upload/v1670859271/coop/coop-logo_svvrp0.png"
            }
            centered
          />
        </Menu.Item>
        {authCtx.user?.group[0] === 'TREASURER' && (<>
          <Menu.Item as='a'
            active={currentPath?.startsWith(
              // `${url}`
            )}
            onClick={() => navigate('/backoffice')}
            style={{ color: '#fff' }}
  
          >
            <span>  <Icon name='home' /></span>Pending Approval
          </Menu.Item>


        </>)}
        {authCtx.user?.group[0] !== 'TREASURER' && (<>

          <Menu.Item as='a'
            active={currentPath?.startsWith(
              // `${url}`
            )}
            onClick={() => navigate('/staff')}
            style={{ color: '#fff' }}

          >
            <span>  <Icon name='home' /></span>Active Booking
          </Menu.Item>

          <Menu.Item as='a'
            active={currentPath?.startsWith(
              `${url}/activities`
            )}
            onClick={() => navigate('activities')}
            style={{ color: '#fff' }}
          >
            <span><Icon name='users' /></span>Daily  Records
          </Menu.Item>

          <Menu.Item as='a'
            active={currentPath?.startsWith(
              `${url}/resturant`
            )}
            onClick={() => navigate('resturant')}
            style={{ color: '#fff' }}
          >
            <span><Icon name='utensils' /></span>Resturant
          </Menu.Item>

  
          <Menu.Item as='a'
            active={currentPath?.startsWith(
              `${url}/monthly-records`
            )}
            onClick={() => navigate('monthly-records')}
            style={{ color: '#fff' }}
          >
            <span>  <Icon name='tasks' /></span>Monthly Records
          </Menu.Item>
          <Menu.Item as='a'
            active={currentPath?.startsWith(
              `${url}/packages`
            )}
            onClick={() => navigate('packages')}
            style={{ color: '#fff' }}
          >
            <span>  <Icon name='building' /></span>Rooms & Hall
          </Menu.Item>

          <Menu.Item as='a'
            active={currentPath?.startsWith(
              `${url}/past-records`
            )}
            onClick={() => navigate('past-records')}
            style={{ color: '#fff' }}
          >
            <span>  <Icon name='hourglass' /></span>Past Records
          </Menu.Item>



          <Menu.Item as='a'
            active={currentPath?.startsWith(
              `${url}/completed-bookings`
            )}
            onClick={() => navigate('completed-bookings')}
            style={{ color: '#fff' }}
          >
            <span>  <Icon name='th' /></span>Past Bookings
          </Menu.Item>
        </>)
        }
        {/* {authCtx.user?.group[0] === 'SUPERADMIN' && (
          <Menu.Item as='a'
            active={currentPath?.startsWith(
              `${url}/reports`
            )}
            onClick={() => navigate('reports')}
            style={{ color: '#fff' }}
          >
            <span>  <Icon name='chart area' /></span>  Reports
          </Menu.Item>
        )} */}

      </Sidebar>

      <Sidebar.Pusher style={{ paddingRight: sideBarVisible ? 150 : 0, minHeight: "100vh", backgroundColor: "#fff", }}>
        <Segment basic>
          <Menu secondary>
            <Menu.Item
              as="a"
              onClick={() => setSidebarVisible(!sideBarVisible)}
            >
              <Icon name="bars" />
            </Menu.Item>
            {authCtx.user?.group[0] !== 'TREASURER' && (
              <Menu.Item position="right" >
                <Dropdown
                  button labeled
                  style={{ color: "red", fontWeight: 'bold', padding: '1.5em' }}
                  text={notifications?.toString()}
                  icon={'bell'}
                >
                  <Dropdown.Menu className="left" >

                    {bookId && bookId.map((item,index) => (
                      <Dropdown.Item
                        text={item.bookingId}
                        key={index}
                      />

                    ))}

                  </Dropdown.Menu>
                </Dropdown>

              </Menu.Item>


            )}
            <Menu.Item position="right" >
              <Dropdown

                floating labeled button
                style={{ color: "black", fontWeight: 'bold' }}
                text={authCtx.user?.firstname || authCtx.user?.email}

              >

                <Dropdown.Menu className="left" >
                  <Dropdown.Item
                    text="Sign-out"
                    label={{ color: 'teal', icon: "sign-out" }}
                    onClick={_logout}
                  />
                </Dropdown.Menu>
              </Dropdown>
            </Menu.Item>
          </Menu>

          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Routes>

                  {authCtx.user?.group[0] === 'TREASURER' && (<Route index element={< BackOffice />} />)}

                  <Route index element={<GuestHouseBookings />} />

                  <Route path={`packages`} element={<GuestHousePackages />} />

                  {/* <Route
                    path={'reports'}
                    element={<Reports />}
                  /> */}
                  <Route
                    path={'activities'}
                    element={<CustomersActivity />}
                  />

                  <Route  path='resturant'   element={<Resturant/>}/>

                  <Route  path='monthly-records'   element={<MonthlyRecords/>}/>

                  <Route
                    path={'completed-bookings'}
                    element={< CompletedBookings />}
                  />

                  <Route
                    path={'past-records'}
                    element={< PastRecords />}
                  />
                  <Route path={`success/:token`} element={<Success />} />

                </Routes>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Sidebar.Pusher>
      <Outlet />
    </Sidebar.Pushable>
  )


}

export default DashboardLayout